"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cancelPaymentRequestInputsDto = exports.PaymentRequestCanceledFilter = void 0;
const zod_1 = require("zod");
var PaymentRequestCanceledFilter;
(function (PaymentRequestCanceledFilter) {
    PaymentRequestCanceledFilter["ALL"] = "all";
    PaymentRequestCanceledFilter["CANCELED"] = "canceled";
    PaymentRequestCanceledFilter["NOT_CANCELED"] = "not_canceled";
})(PaymentRequestCanceledFilter = exports.PaymentRequestCanceledFilter || (exports.PaymentRequestCanceledFilter = {}));
exports.cancelPaymentRequestInputsDto = zod_1.z.object({
    payments: zod_1.z.array(zod_1.z.number()),
});
